import React from 'react';
import moment from 'moment';
import 'moment-duration-format';
import './time-counter.css';

class TimeCounter extends React.Component {
    render() {
        const { duration, title } = this.props;
        const humanizedDuration = moment.duration(duration, 'seconds').format('hh[h] e mm[min]', {
            trim: true,
            usePlural: false,
        });
        return (
            <div>
                <div className='time-header'>
                    {title}
                </div>
                <div className='time-duration'>
                    {humanizedDuration}
                </div>
            </div>
        );
    }
}

export default TimeCounter;



// WEBPACK FOOTER //
// ./src/components/time-counter/time-counter.js